import type { RechercheDemandeQueryDTO, RechercheResultDTO } from '@/features/api/extranet/dto/Demande/Recherche'
import { buildRechercheStore } from '../shared'

export const useRechercheDemandeTTStore = buildRechercheStore<RechercheDemandeQueryDTO, RechercheResultDTO>({
  storeName: 'rechercheDemandeTTStore',
  apiPath: `/specifiquett/demandes`,
  location: {
    to: 'recherche',
    domaine: 'tt',
    module: 'demande',
  },
})
